<!--
CREATE TABLE `merchant_second_group` (
  `id` int(11) NOT NULL AUTO_INCREMENT,
  `second_group_merchant_name` varchar(255) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '商户名称',
  `second_group_merchant_no` varchar(50) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '商户号',
  `second_group_merchant_phone` varchar(20) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '联系电话',
  `open_id` varchar(50) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '操作人员',
  `password` varchar(50) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '操作员交易密码',
  `cert_password` varchar(50) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '证书密码',
  `cert_name` varchar(20) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '证书名称',
  `cert_file` varchar(255) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '证书',
  `status` tinyint(1) DEFAULT '0' COMMENT '0待登记，1已登记，2已通过，3未通过',
  `msg` varchar(255) COLLATE utf8mb4_bin DEFAULT NULL COMMENT '验证信息',
  `create_time` datetime DEFAULT NULL COMMENT '创建时间',
  `update_time` datetime DEFAULT NULL COMMENT '修改时间',
  PRIMARY KEY (`id`),
  KEY `second_group_merchant_name` (`second_group_merchant_name`),
  KEY `second_group_merchant_no` (`second_group_merchant_no`),
  KEY `second_group_merchant_phone` (`second_group_merchant_phone`),
  KEY `merchant_no_second_phone_index` (`second_group_merchant_no`,`second_group_merchant_phone`)
) ENGINE=InnoDB AUTO_INCREMENT=264 DEFAULT CHARSET=utf8mb4 COLLATE=utf8mb4_bin;
-->
<template>
  <div class="main-body">
    <!-- 查询区域 -->
    <div class="search-box">
      <el-input v-model="query.second_group_merchant_name" placeholder="商户名称" size="mini" style="width:200px" />
      <el-input v-model="query.second_group_merchant_no" placeholder="商户号" size="mini" style="width:200px" />
      <el-button type="primary" @click="getList" size="mini">搜索</el-button>
    </div>

    <!-- 表格 -->
    <el-table :data="pageData.list" border height="70vh">
      <el-table-column prop="id" label="ID" width="70" fixed />
      <el-table-column prop="second_group_merchant_name" label="商户名称" width="180" show-overflow-tooltip />
      <el-table-column prop="second_group_merchant_no" label="商户号" width="150" show-overflow-tooltip />
      <el-table-column prop="second_group_merchant_phone" label="联系电话" width="130" />
      <el-table-column prop="open_id" label="操作人员" width="120" show-overflow-tooltip />
      <el-table-column prop="cert_name" label="证书名称" width="100" />
      <el-table-column prop="cert_file" label="证书" width="180" show-overflow-tooltip />
      <el-table-column prop="status" label="状态" width="90">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status===0" type="info">待登记</el-tag>
          <el-tag v-else-if="scope.row.status===1" type="warning">已登记</el-tag>
          <el-tag v-else-if="scope.row.status===2" type="success">已通过</el-tag>
          <el-tag v-else-if="scope.row.status===3" type="danger">未通过</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="msg" label="验证信息" width="180" show-overflow-tooltip />
      <el-table-column prop="create_time" label="创建时间" width="150" />
      <el-table-column prop="update_time" label="修改时间" width="150" />
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @size-change="sizeChange"
      @current-change="pageChange"
      :current-page="pageData.page"
      :page-size="pageData.size"
      layout="total, prev, pager, next,sizes"
      :total="pageData.total"
      :page-sizes="[10, 20, 50, 100]"
      style="margin-top:15px;text-align:right"
    />
  </div>
</template>

<script>
import Http from './common/Http'
import Params from './common/Params'

export default {
  name: 'MerchantSecondGroup',
  data() {
    return {
      query: {
        second_group_merchant_name: "",
        second_group_merchant_no: "",
      },
      pageData: {
        list: [],
        total: 0,
        page: 1,
        size: 20,
      },
      dialogVisible: false,
      form: {}
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      const params = Params.ins()
        .where(this.query.second_group_merchant_name ? ['second_group_merchant_name', 'like', '%' + this.query.second_group_merchant_name + '%'] : null)
        .where(this.query.second_group_merchant_no ? ['second_group_merchant_no', '=', this.query.second_group_merchant_no] : null)
        .order('id desc')
        .page(this.pageData.page)
        .size(this.pageData.size)
        .list()

      Http.post('MerchantSecondGroup/index', params, res => {
        if (res.code === 200) {
          this.pageData = res.data
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },

    pageChange(page) {
      this.pageData.page = page
      this.getList()
    },
    sizeChange(size) {
      this.pageData.size = size
      this.getList()
    },
  }
}
</script>

<style lang="scss" scoped>
@import "./common.scss";
.main-body {
  padding: 15px;

  .search-box {
    margin-bottom: 15px;
    display: flex;
    gap: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Config/PosDevice/MerchantSecondGroup.vue